export default "__VITE_ASSET__JtpE$dQN__"